import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { RegisterSlide } from '@bn/auth/models/sliders/register-slide.model';
import { Trustpilot } from '@bn/auth/models/sliders/trustpilot.model';
import { LazyLoadDirective } from '@bn/web-ui';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { LoadingComponent } from '@bn/web-ui/loading/loading.component';

@Component({
  selector: 'bn-auth-register-slider',
  templateUrl: './register-slider.component.html',
  styleUrls: ['./register-slider.component.scss'],
  imports: [NgClass, ButtonComponent, LoadingComponent, FaIconComponent, LazyLoadDirective],
})
export class RegisterSliderComponent implements OnDestroy {
  @Input()
  public tenantId = '';

  @Input()
  set config(config: RegisterSlide | null) {
    if (config) {
      this.configuration = config;
      this.handleAutoSlide();
    }
  }

  @Input()
  set trustpilotConfig(trustpilotConfig: Trustpilot | undefined) {
    if (trustpilotConfig) {
      this.trustpilotConfiguration = trustpilotConfig;

      this.handleColoredStarsBgWidth();
    }
  }

  @Input()
  public loading = false;

  public activeIndex = 0;
  public interval?: ReturnType<typeof setInterval>;
  public isMouseOver = false;
  public slideInterval = 10000;
  public trustpilotConfiguration: Trustpilot | undefined;
  public configuration: RegisterSlide | null = null;
  public starSize = 18;
  public starPadding = 2;
  public coloredStarsBgWidth = 0;

  public get hoverImageClasses() {
    return { [`bn-register-slider__image--tenant`]: this.tenantId === 'w3' };
  }

  public ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  public onPaginationClick(activeIndex: number): void {
    this.activeIndex = activeIndex;
  }

  public onMouseOver(): void {
    this.isMouseOver = true;
  }

  public onMouseLeave(): void {
    this.isMouseOver = false;
  }

  private handleAutoSlide(): void {
    this.interval = setInterval(() => {
      if (!this.configuration?.comments?.length || this.isMouseOver) return;

      this.activeIndex = this.activeIndex === this.configuration.comments.length - 1 ? 0 : this.activeIndex + 1;
    }, this.slideInterval);
  }

  private handleColoredStarsBgWidth(): void {
    if (!this.trustpilotConfiguration?.rating) return;

    const fullStars = Math.trunc(this.trustpilotConfiguration.rating);
    const remaining = this.trustpilotConfiguration.rating - fullStars;

    this.coloredStarsBgWidth = fullStars * (this.starSize + this.starPadding) + Math.round((this.starSize / 100) * (remaining * 100));
  }
}
